import "../controllers/index"
import "../initializers/turbo_custom_actions"

import "@hotwired/turbo-rails"
Turbo.session.drive = false

import TurboPower from 'turbo_power'
TurboPower.initialize(Turbo.StreamActions)
